import React from "react";

class RatingSummary extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div id="BVRRSummaryContainer"></div>;
  }
}
export default RatingSummary;
